import { ElementRulesEditorViewProps } from "@graffer-inc/form-builder";
import {
  InputElementUnion,
  isFunctionElement,
  isInputElement,
  isRepeatableElement,
  isStaticElement,
} from "@graffer-inc/form-schema";
import { ElementEditorView } from "./element-editor";
import { ConditionalRulesEditors } from "./conditional-rule-editors";
import { RepeatableEditor } from "./editors/repeatable-editor";
import { FunctionElementEditor } from "./editors/function-element-editor/function-element-editor";
import { StaticElementEditor } from "./editors/static-element-editor/static-element-editor";

export const ElementRulesEditorView: React.FC<ElementRulesEditorViewProps> = ({
  schemaBuilder,
  editState,
  onStateUpdate,
}) => {
  const formSchema = schemaBuilder.currentRawSchema;
  return (
    <>
      <div className="px-3 py-3">
        {isInputElement(editState.element) && (
          <ElementEditorView
            element={editState.element}
            currentRawSchema={formSchema}
            onElementUpdate={(e) => {
              onStateUpdate({
                ...editState,
                element: e,
              });
            }}
          />
        )}
        {isRepeatableElement(editState.element) && (
          <RepeatableEditor
            element={editState.element}
            onElementUpdate={(e) => {
              onStateUpdate({
                ...editState,
                element: e,
              });
            }}
          />
        )}
        {isFunctionElement(editState.element) && (
          <FunctionElementEditor
            element={editState.element}
            sections={formSchema.root}
          />
        )}
        {isStaticElement(editState.element) && (
          <StaticElementEditor
            element={editState.element}
            onElementUpdate={(e) => {
              onStateUpdate({
                ...editState,
                element: e,
              });
            }}
          />
        )}
      </div>
      {/**
       * ConditionalRules; not seperated to individual component in form-builder.
       * see: editor-pane/element-editor-pane/element-rules-editor-view.tsx
       */}
      <hr />
      {editState.conditionalRules.length > 0 &&
        editState.conditionalRules.map((target, idx) => (
          <div key={JSON.stringify(target) + idx.toString()}>
            <ConditionalRulesEditors
              formSchema={formSchema}
              editingElement={editState.element as InputElementUnion}
              currentRule={target.rule}
              ruleIndex={target.index}
            />
          </div>
        ))}
      {editState.conditionalRules.length === 0 && (
        <>
          <div
            style={{
              border: "1px solid lightgrey",
            }}
          >
            <div className="columns is-centered is-vcentered has-text-centered pt-6 pb-6">
              <div className="column pt-6 pb-4">
                <p className="has-text-centered has-text-weight-bold mb-2">
                  {editState.element.label.text}
                  には、条件分岐設定はありません
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
